module.exports = __webpack_public_path__ + "static/img/image2.991f1322.png";